import { render } from "./HomeDataDisplay.vue?vue&type=template&id=01dcdcb3"
import script from "./HomeDataDisplay.vue?vue&type=script&lang=js"
export * from "./HomeDataDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__